module.exports = __webpack_public_path__ + "img/info-black-24-dp-3.b2f8e467.svg";